




































import Vue from "vue";
import LoadingModal from "@/components/design/LoadingModal.vue";
import ModalView from "@/components/design/ModalView.vue";
export default Vue.extend({
  components: { LoadingModal, ModalView },
  data() {
    return { showSupportModal: true };
  },
});
